/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsumerSearchModel } from '../../models/consumer-search-model';
import { PractitionerProfileModel } from '../../models/practitioner-profile-model';

export interface ConsumerSearchAsyncPost$Params {
  latitude?: number;
  longitude?: number;
      body?: ConsumerSearchModel
}

export function consumerSearchAsyncPost(http: HttpClient, rootUrl: string, params?: ConsumerSearchAsyncPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<Array<PractitionerProfileModel>>> {
  const rb = new RequestBuilder(rootUrl, consumerSearchAsyncPost.PATH, 'post');
  if (params) {
    rb.query('latitude', params.latitude, {});
    rb.query('longitude', params.longitude, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<Array<PractitionerProfileModel>>;
    })
  );
}

consumerSearchAsyncPost.PATH = '/Consumer/SearchAsync';
